import useLanguage from '@op/hooks/useLanguage';
import React from 'react';
import { Button, Modal } from 'tea-component';
import { ParamsType } from '../type';

export default function DeleteModal({
  closeDeleteModal,
  deleteName,
  type,
  loading,
  confirmDelete
}: {
  closeDeleteModal: () => void;
  deleteName: string;
  type: ParamsType;
  loading: boolean;
  confirmDelete: () => void;
}) {
  const { formatMessage } = useLanguage();

  return (
    <Modal
      className="dbo-weekly-report-delete"
      visible
      onClose={() => closeDeleteModal()}
      caption={formatMessage('Confirm Delete？')}
    >
      <Modal.Body>
        {formatMessage(
          'Delete {name}{type}? Deletion is irreversible, please proceed with caution.',
          {
            name: <b>{deleteName} </b>,
            type: formatMessage(type === 'module' ? 'module-1' : 'version-1'),
          },
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          loading={loading}
          type="primary"
          onClick={() => confirmDelete()}
        >
          {formatMessage('Confirm')}
        </Button>
        <Button type="weak" onClick={() => closeDeleteModal()}>
          {formatMessage('Cancel')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
